export default "__VITE_ASSET__bfAKB_dz__"